var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M10.5,4.5a6,6,0,1,0,6,6A6,6,0,0,0,10.5,4.5Zm.612,9.338a.208.208,0,0,1-.208.208H10.1a.208.208,0,0,1-.208-.208V9.963a.208.208,0,0,1,.208-.208H10.9a.208.208,0,0,1,.208.208Zm-.617-4.948a.73.73,0,0,1-.723-.732.728.728,0,0,1,1.455,0,.732.732,0,0,1-.732.732Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification_icon.1804367005d55d58afa21e07f1b9b0c7.svg";